<template>
  <div class="author-statistic">
    <div>
      <p class="author-statistic__count">
        {{ articleCount }} {{ articleCountText }}
      </p>
      <p v-if="isFollowersCountVisible" class="author-statistic__count">
        {{ followerCount }} followers
      </p>
    </div>

    <div
      v-if="isFollowAuthorButtonVisible"
      class="author-statistic__follow-container"
      @click="onToggleFollowAuthor"
    >
      <a-icon
        :icon="ICON.WALKING_FINGERS_ROUND_BLACK"
        width="auto"
        :height="30"
        :disabled="inProgress"
        is-button
        id="author-follow-icon"
        aria-label="Follow/Unfollow the author"
        class="author-statistic__follow-icon"
      >
        <span slot="additional-info" class="author-statistic__follow-label">{{
          followAuthorButtonText
        }}</span>
      </a-icon>
    </div>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import mixins from '@/utils/mixins'

import AIcon, { ICON } from 'shared/AIcon'
import { METHOD_NAME, PENDING_ACTION } from 'enums/pending-actions'

const MIN_FOLLOWER_COUNT_TO_SHOW = 10

export default {
  name: 'AuthorStatistic',
  mixins: [
    mixins.pendingAuthActions,
    mixins.refreshDataListenersFactory({
      startRefreshHandlerByType: {
        [PENDING_ACTION.FOLLOW_AUTHOR]: METHOD_NAME.HANDLE_START_PENDING_ACTION
      },
      endRefreshHandlerByType: {
        [PENDING_ACTION.FOLLOW_AUTHOR]: METHOD_NAME.HANDLE_END_PENDING_ACTION
      }
    })
  ],
  components: { AIcon },
  props: {
    articleCount: propValidator([PROP_TYPES.STRING, PROP_TYPES.NUMBER]),
    followerCount: propValidator([PROP_TYPES.STRING, PROP_TYPES.NUMBER]),
    isFollowAuthorButtonVisible: propValidator([PROP_TYPES.BOOLEAN]),
    authorId: propValidator([PROP_TYPES.STRING]),
    isFollowed: propValidator([PROP_TYPES.BOOLEAN])
  },
  data() {
    return {
      ICON,
      inProgress: false
    }
  },
  computed: {
    followAuthorButtonText() {
      return this.isFollowed ? 'Unfollow author' : 'Follow author'
    },
    isFollowersCountVisible() {
      return this.followerCount >= MIN_FOLLOWER_COUNT_TO_SHOW
    },
    articleCountText() {
      return this.articleCount === 1 ? 'article' : 'articles'
    }
  },
  methods: {
    onToggleFollowAuthor() {
      const actionData = { id: this.authorId, newValue: !this.isFollowed }

      this.$_pendingAuthActions_handleAction({
        actionType: PENDING_ACTION.FOLLOW_AUTHOR,
        actionData
      })
    },
    [METHOD_NAME.HANDLE_START_PENDING_ACTION](refreshPayload) {
      if (refreshPayload.id === this.authorId) {
        this.inProgress = true
      }
    },
    [METHOD_NAME.HANDLE_END_PENDING_ACTION](refreshPayload) {
      if (refreshPayload.id === this.authorId) {
        this.inProgress = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.author-statistic {
  padding: 20px;
  display: flex;
  justify-content: space-between;

  @include mobile {
    padding: 0;
  }

  & * {
  }

  .author-statistic__count {
    font-size: 14px;
    line-height: 19px;
  }

  .author-statistic__follow-container {
    display: flex;
    align-items: center;
  }

  .author-statistic__follow-label {
    margin-left: 5px;
    padding-right: 3px;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    white-space: nowrap;
  }

  .author-statistic__follow-icon {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

    &:hover {
      .author-statistic__follow-label {
        color: $c--main;
      }
    }
  }
}
</style>
